module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (55).2cf5e367.jpg";